import React from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="82jjlxpPR4U"
                    title="IN-5905 HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-5905 HD Objektivjustage"
              footer={
                <EuiText>
                  <p>Wir zeigen Ihnen in diesem Video wie Sie bei einer INSTAR IN-5905HD Überwachungskamera das Objektiv scharfstellen können. Jenachdem welchen Bereich man überwachen möchte, ist es ggf. nötig das Objektiv auf den gewünschten Bereich einzustellen.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}